const LOCKED_EDIT_STATUSES = new Set([
  "approved",
  "partial approved",
  "partially approved",
  "pended",
  "pending"
  // "rejected",
]);

export const normalizeTransactionStatus = (status) =>
  String(status || "")
    .trim()
    .toLowerCase()
    .replace(/[_-]+/g, " ")
    .replace(/\s+/g, " ");

export const isEditLockedStatus = (status) =>
  LOCKED_EDIT_STATUSES.has(normalizeTransactionStatus(status));
